module.exports = __webpack_public_path__ + "img/tool-pen.c122100d.png";